import {Base} from "@/api/Base"

export class PayModeListAll extends Base {
    path = "payMode/listAll"
}